import React, { ReactElement, useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import TextInput from '../formGroup/TextInput'
import { IStore } from '../../interfaces/Store'
import {
  validateConfirmationEmail,
  validateEmail,
  validateTelephone,
} from '../../services/validation'
import { IContact } from '../../interfaces/Step4'
import { getPrefillPhone } from '../../services/utils'

type FieldName = string

function Contact({
  register,
  errors,
  triggerValidation,
  watch,
  setValue,
}: IContact): ReactElement {
  const {
    email,
    telephone_mobile_1_num,
    telephone_mobile_2_num,
    telephone_mobile_3_num,
    journeyStatus,
  } = useSelector((state: IStore) => state.folderReducer.folder)
  const [showConfirmationEmailField, setShowConfirmationEmailField] = useState(
    false
  )
  const isFirstFocus = useRef<Record<FieldName, boolean>>({
    email: true,
    telephone_mobile_1_num: true,
  })

  const clearOnFocusHandler = (fieldName: string) => {
    if (fieldName === 'email') {
      setShowConfirmationEmailField(true)
    }

    if (isFirstFocus.current[fieldName]) {
      setValue(fieldName, '')
      isFirstFocus.current[fieldName] = false
    }
  }

  const prefillPhone = getPrefillPhone(
    {
      telephone_mobile_1_num,
      telephone_mobile_2_num,
      telephone_mobile_3_num,
    },
    journeyStatus
  )

  const defaultPhoneNumber =
    telephone_mobile_1_num ||
    telephone_mobile_2_num ||
    telephone_mobile_3_num ||
    prefillPhone

  useEffect(() => {
    const confirmationEmail = document.getElementById(
      'email_confirmation'
    ) as HTMLInputElement
    const preventPaste = (event: Event) => {
      event.preventDefault()
    }

    confirmationEmail?.addEventListener('paste', preventPaste)

    return () => {
      confirmationEmail?.removeEventListener('paste', preventPaste)
    }
  })
  const watchEmail = watch('email')

  return (
    <div className="card pt3md pb4md py0lg mb4">
      <div className="cardContent cardSmContent px25 py25">
        <div className="row">
          <div className="col12 px1 px4md px15lg">
            <p className="mb2">
              Indiquez votre adresse e-mail et votre numéro de téléphone à
              privilégier pour vous contacter :
            </p>
          </div>
          <TextInput
            id="email"
            name="email"
            register={register(
              validateEmail(email, showConfirmationEmailField)
            )}
            error={errors.email}
            defaultValue={email}
            label="Adresse e-mail"
            required
            placeHolder="Votre texte ici..."
            maxLength={128}
            className="colMd6 mb3 mb0md pr15md pl4md pl15lg pr3lg"
            inputClassName="inputFieldSecondary"
            triggerValidation={triggerValidation}
            onFocus={() => clearOnFocusHandler('email')}
          />
          {showConfirmationEmailField && (
            <TextInput
              id="email_confirmation"
              name="email_confirmation"
              register={register(validateConfirmationEmail(watchEmail))}
              error={errors.email_confirmation}
              defaultValue=""
              label="Vérification de l'adresse e-mail"
              required
              placeHolder="Votre texte ici..."
              maxLength={128}
              className="colMd6 mb25 px4 pr4md pr15lg pl15md pl3lg"
              inputClassName="inputFieldSecondary"
              triggerValidation={triggerValidation}
            />
          )}
          <TextInput
            id="telephone_mobile_1_num"
            name="telephone_mobile_1_num"
            register={register(validateTelephone(defaultPhoneNumber))}
            error={errors.telephone_mobile_1_num}
            defaultValue={defaultPhoneNumber}
            label="Téléphone à privilégier (mobile de préférence)"
            placeHolder="06..."
            maxLength={15}
            required
            className="colMd6 mb15 mb0md pr15md pl4md pl15lg pr3lg"
            inputClassName="inputFieldSecondary"
            triggerValidation={triggerValidation}
            onFocus={() => clearOnFocusHandler('telephone_mobile_1_num')}
          />
        </div>
      </div>
    </div>
  )
}

export default Contact
